var themedBackground = {
  light: "var(--ds-surface, #FFFFFF)",
  dark: "var(--ds-surface, #1B2638)"
};

/**
 * Returns the background color depending on the passed through mode.
 * @param mode
 */
export var getBackground = function getBackground() {
  var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';
  return themedBackground[mode];
};